var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongratsKetogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "44eom2q2ma",
    d: "M0 0h14.658v14.769H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#569A4F",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.09 16.616)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9svh68zlqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#44eom2q2ma"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.44 6.55h7.218c0 .742-.032 1.416-.093 2.022a7.202 7.202 0 0 1-.371 1.689 6.734 6.734 0 0 1-1.058 1.938 6.178 6.178 0 0 1-1.567 1.41 7.36 7.36 0 0 1-1.977.863 8.476 8.476 0 0 1-2.263.297c-1.089 0-2.082-.18-2.978-.538a6.717 6.717 0 0 1-2.31-1.512A6.837 6.837 0 0 1 .538 10.38C.18 9.472 0 8.467 0 7.366c0-1.089.176-2.088.529-2.997A6.584 6.584 0 0 1 2.03 2.041 6.83 6.83 0 0 1 4.38.538C5.294.179 6.314 0 7.44 0c1.46 0 2.74.315 3.841.946 1.1.631 1.973 1.608 2.616 2.932l-3.451 1.429c-.322-.768-.74-1.318-1.253-1.652a3.145 3.145 0 0 0-1.753-.501c-.544 0-1.04.102-1.484.306a3.208 3.208 0 0 0-1.141.872 4.188 4.188 0 0 0-.742 1.364 5.548 5.548 0 0 0-.27 1.781c0 .594.077 1.144.232 1.651.155.508.387.947.696 1.318.31.37.693.658 1.15.863.458.204.99.306 1.596.306.359 0 .705-.04 1.04-.12.334-.082.633-.21.9-.39.265-.18.484-.411.658-.696.173-.284.29-.631.353-1.04H7.44V6.55z",
    fill: "#FFF",
    mask: "url(#9svh68zlqb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.155 16.615c1.126 0 2.165.19 3.117.567.953.377 1.772.899 2.459 1.567a7.178 7.178 0 0 1 1.605 2.347A7.31 7.31 0 0 1 39.91 24c0 1.04-.192 2.007-.575 2.904a7.172 7.172 0 0 1-1.605 2.347 7.363 7.363 0 0 1-2.459 1.567c-.952.378-1.991.567-3.117.567-1.138 0-2.18-.19-3.126-.567a7.273 7.273 0 0 1-2.44-1.567 7.234 7.234 0 0 1-1.596-2.347A7.307 7.307 0 0 1 24.418 24c0-1.04.192-2.007.575-2.904a7.24 7.24 0 0 1 1.596-2.347 7.282 7.282 0 0 1 2.44-1.567c.946-.378 1.988-.567 3.126-.567zm-1.71 4.529v5.712L35.49 24l-5.044-2.856z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsKetogo);
export default __webpack_public_path__ + "static/media/congratsKetogo.d5cc3ed9.svg";
export { ForwardRef as ReactComponent };